<p>search-manager works!</p>
